var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcNavSystemTask = function SvgIcNavSystemTask(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M18.545 3H5.455C4.064 3 3 4.064 3 5.455v3.272c0 1.391 1.064 2.455 2.455 2.455h13.09c1.391 0 2.455-1.064 2.455-2.455V5.455C21 4.064 19.936 3 18.545 3zm.819 5.727c0 .491-.328.818-.819.818H5.455c-.491 0-.819-.327-.819-.818V5.455c0-.491.328-.819.819-.819h13.09c.491 0 .819.328.819.819v3.272zm-.819 4.091H5.455C4.064 12.818 3 13.882 3 15.273v3.272C3 19.936 4.064 21 5.455 21h13.09C19.936 21 21 19.936 21 18.545v-3.272c0-1.391-1.064-2.455-2.455-2.455zm.819 5.727c0 .491-.328.819-.819.819H5.455c-.491 0-.819-.328-.819-.819v-3.272c0-.491.328-.818.819-.818h13.09c.491 0 .819.327.819.818v3.272zM7.664 6.518a.745.745 0 0 1 .245.573.746.746 0 0 1-.245.573.746.746 0 0 1-.573.245.743.743 0 0 1-.573-.245c-.082-.082-.163-.164-.163-.246-.082-.082-.082-.245-.082-.327 0-.082 0-.246.082-.327.081-.082.081-.164.163-.246.082-.082.164-.163.246-.163a.9.9 0 0 1 .654 0c.082 0 .164.081.246.163zm0 9.818a.746.746 0 0 1 .245.573c0 .246-.082.41-.245.573a.746.746 0 0 1-.573.245.743.743 0 0 1-.573-.245.745.745 0 0 1-.245-.573c0-.082 0-.245.082-.327.081-.082.081-.164.163-.246a.792.792 0 0 1 1.146 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcNavSystemTask);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-nav-system-task.a71ae24eb975b6934c76c07a58794a55.svg";